import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ProgressCheck } from "../../../../assets/icons";
import { MyTeamSurveySummaryDTO } from "../../../../models/my-team-survey-summary/my-team-survey-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const OpenSurveysLink = ({ customSummary, loading }: { customSummary: MyTeamSurveySummaryDTO; loading: boolean }) => {
  const tRP = "components.custom_widget_links.employee_surveys.open_surveys";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.openSurveys?.toString() ?? "0"}
      description={`${t(`${tRP}`)}`}
      Icon={ProgressCheck}
      IconStyle={{
        color: theme.palette.primary.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
    />
  );
};
export default OpenSurveysLink;
